/**
 * @generated SignedSource<<c29e171640e6ade6f174ad621a9356f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MinimalAnnouncementCard_announcement$data = {
  readonly announcer: {
    readonly " $fragmentSpreads": FragmentRefs<"UserHandle_member">;
  };
  readonly id: string;
  readonly publishedAt: ISO8601DateTimeString | null;
  readonly space: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"SpaceIndicator_space">;
  };
  readonly " $fragmentType": "MinimalAnnouncementCard_announcement";
};
export type MinimalAnnouncementCard_announcement$key = {
  readonly " $data"?: MinimalAnnouncementCard_announcement$data;
  readonly " $fragmentSpreads": FragmentRefs<"MinimalAnnouncementCard_announcement">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MinimalAnnouncementCard_announcement",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SpaceIndicator_space"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Member",
      "kind": "LinkedField",
      "name": "announcer",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserHandle_member"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Announcement",
  "abstractKey": null
};
})();

(node as any).hash = "0b509fd3e6a8e0bc28d32101fb74ed9f";

export default node;
